import { pageMessagesRef } from "./firebaseconn";

export async function getPageMessages() {
  try {
    const pageMessages = await pageMessagesRef.get();
    return pageMessages.data();
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}
